import { useQuery } from 'react-query';
import { useContract, useProvider } from 'wagmi';

import { Potion } from '~/../api/common.types';
import { potionABI } from '~/abis/potion';
import { POTION_ADDRESS } from '~/constants';
import { useGetAccount } from '~/hooks/web3/useGetAccount';

// TODO: see if can clean up getPotionQuery

export const getPotionQuery = async (
  signerAddress,
  contract
): Promise<[Potion] | []> => {
  if (contract?.provider) {
    const balance = await contract.balanceOf(signerAddress);
    const totalNFTs: [Potion] | any = [];
    for (let i = 0; i < balance.toNumber(); i++) {
      const tokenId = await contract.tokenOfOwnerByIndex(signerAddress, i);
      const nftURL = await contract.tokenURI(tokenId);
      const response = await fetch(nftURL);
      const nftResponse = await response.json();
      totalNFTs.push(nftResponse);
    }
    return totalNFTs;
  }
  return [];
};

export function useGetPotionNFTs({
  walletIsConnected,
}: {
  walletIsConnected: boolean;
}) {
  // const { data: signer } = useSigner();
  const provider = useProvider();
  const { data: connectedAccount } = useGetAccount();
  const contract = useContract({
    address: POTION_ADDRESS,
    abi: potionABI,
    signerOrProvider: provider,
  });
  const signerAddress = connectedAccount?.address;
  return useQuery(
    ['getPotions', signerAddress],
    () => getPotionQuery(signerAddress, contract),
    {
      enabled: walletIsConnected && !!contract,
      refetchOnWindowFocus: true,
    }
  );
}
